import React, { useState } from 'react'
import { IonLabel, IonItem, IonButton, IonCard } from '@ionic/react'
import { exportData, importData, deleteDatabase, exportToExcelAll, importfromExcel } from '../../resources/db'
import { toastController } from '@ionic/core';
import GoogleBackup from '../../components/Services/GoogleBackup';
import './settings.css'
import { deleteAlert } from '../../contexts/helperFn';

const BackupRestore = () => {

    const [fileImported, setfileImported] = useState(0);
    const [xlFile, setXlFile] = useState(null);

    /** Import the Backup file and Restore the database */
    const fileSubmit = () => {
        let elem = document.getElementById("file");

        let file = elem.files[0];
        if (!file) {
            console.log('filepl x');

            toastController.create({
                message: 'Add a file',
                color: 'dark',
                isOpen: true,
                position: "top",
                duration: 2000
            }).then(toast => {
                toast.present();
            })
            return;
        }
        console.log("Importing " + file.name);
        importData(file).then(res => {
            setfileImported(res);
            console.log("submited");
            window.location.assign('/');
        });
    };

    const fileImportSuccessfully = fileImported ? (
        <div>
            <p className="green-text">Data has been imported successfully.</p>
            <p className="red-text">Reload page to load data.</p>
        </div>
    ) : (<></>);

    return (
        <IonCard>
            <IonItem>
                <IonLabel>Backup Data</IonLabel>
                <IonButton shape='round' expand='block' onClick={exportData}>Backup</IonButton>
            </IonItem>
            <IonItem>
                <IonLabel>Backup Data to Excel</IonLabel>
                <IonButton shape='round' expand='block' onClick={exportToExcelAll}>Backup Excel</IonButton>
            </IonItem>
            <IonItem>
                <IonLabel>Import Data</IonLabel>
                <input id='file' type='file' accept='.dbcx'></input>
                <IonButton shape='round' onClick={() => {
                    fileSubmit();
                }}>Import</IonButton>
            </IonItem>
            <IonItem>
                <IonLabel>Import Via Excel File</IonLabel>
                <input id='filexls' type='file' accept='.xlsx' onChange={(e) => {
                    let file = e.target.files[0];
                    setXlFile(file);
                    console.log("Importing " + file.name);
                }}></input>
                <IonButton shape='round' onClick={() => {
                    if (!xlFile) {
                        toastController.create({
                            message: 'Add a file',
                            color: 'dark',
                            isOpen: true,
                            position: "top",
                            duration: 2000
                        }).then(toast => {
                            toast.present();
                        })
                        return;
                    }
                    importfromExcel(xlFile).then(res => {
                        if (res) {
                            toastController.create({
                                message: 'Data has been imported successfully. Please refresh the App.',
                                color: 'dark',
                                isOpen: true,
                                position: "top",
                                duration: 2000
                            }).then(toast => {
                                toast.present();
                                window.location.reload();
                            })
                        }
                        else {
                            toastController.create({
                                message: 'Error in importing data.',
                                color: 'dark',
                                isOpen: true,
                                position: "top",
                                duration: 2000
                            }).then(toast => {
                                toast.present();
                            })
                        }
                    });
                }}>Import XLSX</IonButton>
            </IonItem>
            <IonItem>
                <IonLabel>Delete Data</IonLabel>
                <IonButton shape='round' expand='block' onClick={() => {
                    deleteAlert("Are you sure?", 'Are you sure you want to delete the database ?', () => {
                        deleteDatabase();
                        window.location.reload();
                    })
                }}>Delete</IonButton>
            </IonItem>

            <GoogleBackup />

            {fileImportSuccessfully}
        </IonCard>
    )
}

export default BackupRestore
